/**
 * @Description:
 * @Author: jiaxiuc
 * @Date: 2024-04-02
 * @LastEditors: jiaxiuc
 * @LastEditTime: 2024-04-11
 */
export default {
  固定值: '固定值',
  主对象配置: '主对象配置',
  子对象配置: '子对象配置',
  字段参数重复: '字段参数重复',
  合同模板: '合同模板',
  映射规则: '映射规则',
  数据源接口: '数据源接口',
  开始同步: '开始同步',
  默认视图: '默认视图',
  列表同步接口: '列表同步接口',
  '将烽火某个对象满足条件的数据同步到飞书合同，飞书合同用下拉单选字段进行承接': '将烽火某个对象满足条件的数据同步到飞书合同，飞书合同用下拉单选字段进行承接',
  数据回填接口: '数据回填接口',
  接口名称: '接口名称',
  接口地址: '接口地址',
  请输入接口名称进行搜索: '请输入接口名称进行搜索',
  监听的合同阶段: '监听的合同阶段',
  监听的合同范围: '监听的合同范围',
  请选择监听的合同阶段: '请选择监听的合同阶段',
  监听的业务类型: '监听的业务类型',
  请选择监听的业务类型: '请选择监听的业务类型',
  确认: '确认',
  字段参数: '字段参数',
  字段名: '字段名',
  枚举值: '枚举值',
  补充: '补充',
  设置枚举值: '设置枚举值',
  批量处理枚举值: '批量处理枚举值',
  批量处理: '批量处理',
  根节点: '根节点',
  请输入字段参数: '请输入字段参数',
  请输入字段名: '请输入字段名',
  请输入接口名称: '请输入接口名称',
  参数名: '参数名',
  请求参数: '请求参数',
  新建参数: '新建参数',
  回填参数: '回填参数',
  回填字段: '回填字段',
  请选择回填参数: '请选择回填参数',
  请选择回填字段: '请选择回填字段',
  请添加回填字段: '请添加回填字段',
  label对应字段: 'label对应字段',
  请选择label对应字段: '请选择label对应字段',
  value对应字段: 'value对应字段',
  添加子节点: '添加子节点',
  '枚举值,说明:请使用英文逗号分隔': '枚举值,说明:请使用英文逗号分隔',
  配置同步规则: '配置同步规则',
  '或（or）': '或（or）',
  合同创建时: '合同创建时',
  审批发起时: '审批发起时',
  审批完成时: '审批完成时',
  盖章发起时: '盖章发起时',
  归档发起时: '归档发起时',
  归档完成时: '归档完成时',
  节点通过时: '节点通过时',
  节点拒绝时: '节点拒绝时',
  节点撤回时: '节点撤回时',
  合同重新提交时: '合同重新提交时',
  合同作废时: '合同作废时',
  合同申请: '合同申请',
  '合同变更（补充协议）': '合同变更（补充协议）',
  合同终止: '合同终止',
  合同组申请: '合同组申请',
  合同信息修改: '合同信息修改',
  合同原始信息: '合同原始信息',
  合同到期: '合同到期',
  '筛选 ·': '筛选 ·',
  满足以下筛选条件: '满足以下筛选条件',
  全选: '全选',
  飞书合同: '飞书合同',
  数据ID: '数据ID',
  开启配置: '开启配置',
  已开启配置: '已开启配置',
  '格式：枚举值,说明,枚举值,说明....，请注意使用英文逗号分隔': '格式：枚举值,说明,枚举值,说明....，请注意使用英文逗号分隔',
  '开启配置后，不支持关闭配置。如您不再同步飞书合同相关信息，只需关闭同步开关即可': '开启配置后，不支持关闭配置。如您不再同步飞书合同相关信息，只需关闭同步开关即可',
  '开启配置后，烽火将自动同步飞书合同接口标准字段': '开启配置后，烽火将自动同步飞书合同接口标准字段',
  '开启配置后，请先检查【合同模板】、【映射规则】、【同步规则】进行设置，再开始同步飞书合同': '开启配置后，请先检查【合同模板】、【映射规则】、【同步规则】进行设置，再开始同步飞书合同',
  请选择主对象主键: '请选择主对象主键',
  '飞书合同某个字段变化时，调用该接口，获取烽火相关单据信息': '飞书合同某个字段变化时，调用该接口，获取烽火相关单据信息',
  飞书合同数据同步插件: '飞书合同数据同步插件',
  '飞书合同以数据ID的方式进行请求时，将烽火对应单据信息进行回填': '飞书合同以数据ID的方式进行请求时，将烽火对应单据信息进行回填',
  完善说明: '完善说明',
  完善枚举值: '完善枚举值',
  自动获取字段: '自动获取字段',
  飞书合同编号: '飞书合同编号',
  请输入飞书合同编号: '请输入飞书合同编号',
  取消: '取消',
  合同模板详情: '合同模板详情',
  新增: '新增',
  任务名称: '任务名称',
  请输入任务名称: '请输入任务名称',
  从烽火字段: '从烽火字段',
  请选择: '请选择',
  到飞书合同字段: '到飞书合同字段',
  请输入飞书合同分组名称: '请输入飞书合同分组名称',
  请输入飞书合同字段名称: '请输入飞书合同字段名称',
  启用状态: '启用状态',
  保存: '保存',
  '请确认：停用后该任务不再生效': '请确认：停用后该任务不再生效！',
  '请选择烽火对象/字段': '请选择烽火对象/字段',
  请选择飞书合同字段: '请选择飞书合同字段'
};
